import { Component, Input, SimpleChanges, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Subject } from 'rxjs';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { NotificationAddRecipientsTemplateComponent } from '../notification-add-recipients-template/notification-add-recipients-template.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationAddRecipientService } from '../notification-add-recipients-template/notification-add-recipients-template.service';
import { SnackbarService } from '../../services/snackbar.service';
import { CommonModule } from '@angular/common';
import { ColumnIssue, ImportDialogFileComponent } from '../../create-notification/recipientslist/import-dialog-file/import-dialog-file.component';
import { FormsModule } from '@angular/forms';
import { RexisSapDialogComponent } from '../../rexis-sap-dialog/rexis-sap-dialog.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'dl-notification-add-recipients-template-dialog',
  standalone: true,
    imports: [OneWebComponentsAngularModule,FormsModule,ImportDialogFileComponent,RexisSapDialogComponent,NotificationAddRecipientsTemplateComponent,CommonModule],
  templateUrl: './notification-add-recipients-template-dialog.component.html',
  styleUrl: './notification-add-recipients-template-dialog.component.scss'
})
export class NotificationAddRecipientsTemplateDialogComponent {

  @Output() closed = new EventEmitter<any>();

  @ViewChild('EmptyContactTemplate') recipientTemplate: TemplateRef<any>;
  public emptyContactList: any;
  public manualAddRecipient: boolean = false;
  public fromRexisap: boolean = false;
  public openFromFile: boolean = false;
  // Blank column warning modal
  public showBlankColumnWarning = false;
  public blankColumnIssues: ColumnIssue[] = [];

  public handleBlankColumnsDetected(issues: ColumnIssue[]): void {
    this.blankColumnIssues = issues;
    this.showBlankColumnWarning = true;
  }

  public formatEmptyRows(rows: number[]): string {
    const max = 10;
    if (rows.length <= max) return rows.join(', ');
    return `${rows.slice(0, max).join(', ')} (+${rows.length - max} more)`;
  }
  public fileData = [];
  @Input() data: any;
  public columnData: any;
   public notificationData: any;
  public templateColumn: any;
  public templateData: any;
  public contactList: any;
  public newFeedbackOption: Subject<any> = new Subject<any>();
  public isSendNotificationDisabled = true;
  public isDeleteDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow = [];
  public isAddRecipientBtnExpanded:boolean = false;
  public isAddRecipientBtnDisabled:boolean = false;
  arrayBuffer: any;
  isDeleteDisabledCheck_dialog:Subject<any> = new Subject<any>();
  public dialogRefEmpty: any;
  public isLimit = false;
  public contactLimitNumber: number = 5000;
  public isWarn: boolean = false;
  public isLimitDis: boolean = true;
  public isWarnDis: boolean = true;
  public excessList: number = 0;
  public inputData: any;
  public duplicates: any[] = [];
  public duplicates$: Subject<any[]> = new Subject<any[]>();

  public constructor( 
    private qnSbnService:QnSbnService,
    private readonly _addRecipientTempService:NotificationAddRecipientService,
    private snackBarNotification: SnackbarService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      const incoming = changes['data'].currentValue;
      
      this.isWarn = false;
      this.isWarnDis = true;
      this.isLimit = false;
      this.isLimitDis = true;
      this.duplicates = [];
      this.excessList = 0;

      this.notificationData = incoming.notificationData || null;
      this.templateColumn = incoming.columnData || [];
      this.templateData = incoming.tableData || [];
      this.contactList = incoming.contactList || [];
    }
  }


  ngOnInit(): void {
    this.isWarn = false;
    this.isWarnDis = true;
    this.isLimit = false;
    this.isLimitDis = true;
    this.duplicates = [];
    this.excessList = 0;
    this.isSendNotificationDisabled = true;
    this.isDeleteDisabled = true;
  }

  public newTemplateClicked(): void {
    this.isNtBtnDisabled = true;
    this.newFeedbackOption.next("Manual");

    const totalList = [...this.contactList, ...this._addRecipientTempService.list];
    if(totalList.length <= this.contactLimitNumber){
      this.isLimit = false;
      this.isLimitDis = false;
    }else{
      this.isLimit = true;
      this.isLimitDis = true;
      this.excessList = totalList.length - this.contactLimitNumber;
    }

   const duplicates = this.findDuplicates(this.contactList, this._addRecipientTempService.list);
    if(duplicates.length > 0){
      this.duplicates$.next(duplicates);
      this.isWarn = true;
      this.isWarnDis = true;
    }else{
      this.duplicates$.next([]);
      this.isWarn = false;
      this.isWarnDis = false;
    }
  }

  public feedbackOptionAdded(isAdded: { isOptAdded: boolean; isSendNotificationDisable: boolean }): void {
    this.isAddRecipientBtnDisabled = !isAdded.isOptAdded;
  }

  public getSelectedRowInTemplate(rows: any): void {
    this.isDeleteDisabled = rows['rowSelected'];
    // this.isSendNotificationDisabled = rows['rowSelected'];
  }

  public getTableData(data: any): void {
    this.isSendNotificationDisabled = this._addRecipientTempService.list.length < 1;

    const totalList = [...this.contactList, ...this._addRecipientTempService.list];
    if(totalList.length <= this.contactLimitNumber){
      this.isLimit = false;
      this.isLimitDis = false;
    }else{
      this.isLimit = true;
      this.isLimitDis = true;
      this.excessList = totalList.length - this.contactLimitNumber;
    }

    const duplicates = this.findDuplicates(this.contactList, this._addRecipientTempService.list);
    if(duplicates.length > 0){
      this.duplicates$.next(duplicates);
      this.isWarn = true;
      this.isWarnDis = true;
    }else{
      this.duplicates$.next([]);
      this.isWarn = false;
      this.isWarnDis = false;
    }
    
  }

  public cancelClicked(){
    this.isAddRecipientBtnDisabled = false;
    this._addRecipientTempService.changeUpdate(0,[]);
    this._addRecipientTempService.list.length = 0;
    this._addRecipientTempService.list$.next(this._addRecipientTempService.list);
    
    this.isWarn = false;
    this.isWarnDis = true;
    this.isLimit = false;
    this.isLimitDis = true;
    this.duplicates = [];
    this.duplicates$.next([]);
    this.templateData = [];
    this.excessList = 0;
    this.isSendNotificationDisabled = true;
    this.isDeleteDisabled = true;
    
    this.closed.emit(null);
  }

  public sendNotificationCall(){
    let newRecipientData = this._addRecipientTempService.addRecipientsList(this.notificationData);
    this.qnSbnService.addNewRecipientList(newRecipientData).subscribe({
      next: (dt) => {
        this.qnSbnService.getNotificationContactDetails(this.notificationData.NotificationId).subscribe(
          (newData:any) => {
            this.qnSbnService.getAccountList(this.notificationData.NotificationId).subscribe(
              (res: any) =>{
                this._addRecipientTempService.list.length = 0;
                this._addRecipientTempService.list$.next(this._addRecipientTempService.list);
                this.closed.emit({ data: newData, accData: res.body });
                this.snackBarNotification.snackBarMessage('positive', 'Recipient added successfully');
              },
              (err: HttpErrorResponse) => {
                this.qnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
              }
            );
          },
          (error: HttpErrorResponse) => {
            this.qnSbnService.httpErrorHandler(error, 'Could not add recipients.');
          }
        );
      },
      error: (err: HttpErrorResponse) => {
        try {
          const errorBody = JSON.parse(err.error?.errorMessage || '{}');
          if (errorBody.statusCode === 403 && errorBody.body?.error) {
            this.snackBarNotification.snackBarMessage('alarm', errorBody.body.error);
          } else {
            this.qnSbnService.httpErrorHandler(err, 'Could not add recipients.');
          }
        } catch {
          this.qnSbnService.httpErrorHandler(err, 'Could not add recipients.');
        }
      }
    });
  }

  manualAddRecipientClicked(){
    this.isAddRecipientBtnExpanded = false;
    this.isAddRecipientBtnDisabled = true;
    this.newTemplateClicked();
  }
  contactListImportClicked(){ 
    this.isAddRecipientBtnExpanded = false;
    this.inputData = { fileData: this.fileData, columnData: this.columnData }
    this.openFromFile = true;
  }

  handleDialogClose(result: any) {
  this.openFromFile = false; // close modal

  if (!result) {
    return; // user cancelled
  }

  this.fileData = result.fileData;
  this.columnData = result.columnData;

  this.emptyContactList = this.validateContactList(this.fileData);
  if (this.emptyContactList.emptyDataRow && this.emptyContactList.emptyDataRow.length > 0) {
    // open another modal for empty rows if needed
    this.dialogRefEmpty = true;
    return;
  }

  if (this.fileData) {
    const jsData = this.fileData.map((data: any) => {
      return {
        customerId: data[this.columnData.Customer_ID],
        customerName: data[this.columnData.Customer_name],
        customerContactName: data[this.columnData.Customer_contact_name],
        customerEmail: data[this.columnData.Customer_contact_email],
        sourceName: result.sourceName
      };
    });
    this.newFeedbackOption.next(jsData);
  }
}

  public validateContactList(contactList: any) {
    let invalidRecordIndex = [];
    let customEmptyData = [];
    const emptyRecords = contactList.filter((item, i) => {
      if (!item[this.columnData?.Customer_contact_email] || 
      item[this.columnData?.Customer_contact_email].trim() === '') {
        customEmptyData.push(
          {
            rowIndex: i+1,
            customerId: item[this.columnData?.Customer_ID] || '',
            customerName: item[this.columnData?.Customer_name] || '',
            customerContactName: item[this.columnData?.Customer_contact_name] || ''
          }
        );
        return item;
      };
    });
    const invalidData = {
      emptyData: emptyRecords,
      emptyDataRow: customEmptyData
    };
    return invalidData;
  }

  public closeEmptyAlertDialog() {
    this.dialogRefEmpty.close();
  }

  addRecipientClicked(){
    this.isAddRecipientBtnExpanded = !this.isAddRecipientBtnExpanded;
  }

  deleteRows(){
    this.isDeleteDisabledCheck_dialog.next('deleteClicked');
    this.isSendNotificationDisabled = this._addRecipientTempService.list.length < 1;

    const totalList = [...this.contactList, ...this._addRecipientTempService.list]
    if(totalList.length <= this.contactLimitNumber){
      this.isLimit = false;
      this.isLimitDis = false;
    }else{
      this.isLimit = true;
      this.isLimitDis = true;
      this.excessList = totalList.length - this.contactLimitNumber;
    }

    const duplicates = this.findDuplicates(this.contactList, this._addRecipientTempService.list);
    if(duplicates.length > 0){
      this.duplicates$.next(duplicates);
      this.isWarn = true;
      this.isWarnDis = true;
    }else{
      this.duplicates$.next([]);
      this.isWarn = false;
      this.isWarnDis = false;
    }
  }

  public findDuplicates(array1, array2) {
    const duplicates = [];
    const foundDuplicates = new Set();

    function addIfNotDuplicate(obj) {
        const objString = JSON.stringify(obj);
        if (!foundDuplicates.has(objString)) {
            duplicates.push(obj);
            foundDuplicates.add(objString);
        }
    }

    array1.forEach(obj1 => {
        array2.forEach(obj2 => {
            if (obj1.CustomerId === obj2.customerID) {
                if (obj1.CustomerContactEmail === obj2.customerContactEmail) {
                    addIfNotDuplicate(obj2);
                } else {
                    if (obj1.CustomerName !== obj2.customerName) {
                        addIfNotDuplicate(obj2);
                    }
                }
            }
        });
    });

    // Condition 1 and 2 within array2 itself
    array2.forEach((obj2, index2) => {
        array2.slice(index2 + 1).forEach(obj2Compare => {
            if (obj2.customerID === obj2Compare.customerID) {
                if (obj2.customerContactEmail === obj2Compare.customerContactEmail) {
                    addIfNotDuplicate(obj2Compare);
                } else if (obj2.customerName !== obj2Compare.customerName) {
                    addIfNotDuplicate(obj2Compare);
                }
            }
        });
    });

    return duplicates;
  }

  public contactListFromRexisSap(){
    this.isAddRecipientBtnExpanded = false;
    this.data = {Country: this.notificationData.Country}
    this.fromRexisap = true;
    
  }

  public onRexisSapClosed(resData: any) {
  this.fromRexisap = false; // close modal

  if (resData && resData !== 'cancel') {
    const jsData = resData.map((data: any) => {
      return {
        customerId: data.erpAccountNo,
        customerName: data.accountName || data.name,
        customerContactName: data.contactName,
        customerEmail: data.contactEmail,
        sourceName: 'Rexis/SAP'
      };
    });
    this.newFeedbackOption.next(jsData);
  } else if (resData === 'cancel') {
   
  } else {
    this.snackBarNotification.snackBarMessage(
      'alarm',
      'There is some problem with recipient list'
    );
  }
}

}
